import generateModifiedEventTraits from './generate-modified-event-traits';

const getSettingEventTraitsPrefix = (settings, settingId) =>
  settings.find((setting) => setting.id === settingId)?.eventTraitPrefix || settingId;

const sortDiffBySettingId = (diff, changedOptions, initialState) => {
  const diffEntries = Object.entries(diff) || [];

  return diffEntries.reduce((result, [elementId, diffValues]) => {
    const diffAttributes = Object.keys(diffValues) || [];

    return diffAttributes.reduce((updatedResult, attribute) => {
      const option = changedOptions[elementId][attribute];
      const oldValue = initialState[elementId][attribute];
      const newValue = diffValues[attribute];

      if (!option?.settingId) return updatedResult;

      return {
        ...updatedResult,
        [option.settingId]: {
          ...(updatedResult[option.settingId] || {}),
          [attribute]: {
            option,
            oldValue,
            newValue,
          },
        },
      };
    }, result);
  }, {});
};

const getModifiedOptionsTraits = (diff, changedOptions, initialState, matchedSettings) => {
  const sortedDiffBySettingId = sortDiffBySettingId(diff, changedOptions, initialState);

  const traits = Object.entries(sortedDiffBySettingId).reduce((acc, [settingId, attributes]) => {
    const attributesWithValues = Object.entries(attributes).filter(
      ([, { newValue }]) => typeof newValue !== 'boolean'
    );
    const eventTraitPrefix = getSettingEventTraitsPrefix(matchedSettings, settingId);

    attributesWithValues.forEach(([attribute, paramas]) => {
      const { option, newValue, oldValue } = paramas;
      let attributeRelatedTraits = {};

      if (typeof option?.getModifiedEventTraits === 'function') {
        attributeRelatedTraits = option.getModifiedEventTraits({
          eventTraitPrefix,
          optionId: option.id,
          attribute,
          newValue,
          oldValue,
        });
      }

      if (!Object.keys(attributeRelatedTraits).length) {
        attributeRelatedTraits = generateModifiedEventTraits(
          eventTraitPrefix,
          option.id,
          oldValue,
          newValue
        );
      }

      Object.assign(acc, attributeRelatedTraits);
    });

    return acc;
  }, {});

  return traits;
};

export default getModifiedOptionsTraits;
